"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleParts = exports.ODataFuncs = void 0;
var jinqu_1 = require("jinqu");
exports.ODataFuncs = {
    apply: "apply",
    expand: "expand",
    filter: "filter",
    oDataSelect: "oDataSelect",
    thenExpand: "thenExpand",
    top: "top",
};
var orderFuncs = [jinqu_1.QueryFunc.orderBy, jinqu_1.QueryFunc.orderByDescending];
var thenFuncs = [jinqu_1.QueryFunc.thenBy, jinqu_1.QueryFunc.thenByDescending];
var descFuncs = [jinqu_1.QueryFunc.orderByDescending, jinqu_1.QueryFunc.thenByDescending];
var otherFuncs = [jinqu_1.QueryFunc.inlineCount, jinqu_1.QueryFunc.skip, jinqu_1.QueryFunc.count, exports.ODataFuncs.filter, exports.ODataFuncs.top];
var mathFuncs = ["round", "floor", "ceiling"];
var aggregateFuncs = ["sum", "max", "min"];
var functions = {
    getDate: "day",
    getFullYear: "year",
    getHours: "hour",
    getMinutes: "minute",
    getMonth: "month",
    getSeconds: "second",
    includes: "contains",
    substr: "substring",
    toLowerCase: "tolower",
    toUpperCase: "toupper",
};
var rootLambda;
function handleParts(parts) {
    var e_1, _a;
    rootLambda = true;
    var options = [];
    var params = {};
    var queryParams = [];
    var expands = [];
    var inlineCount = false;
    var includeResponse = false;
    var orders = [];
    var select;
    var apply;
    var ctor;
    try {
        for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
            var part = parts_1_1.value;
            if (part.type === jinqu_1.AjaxFuncs.options) {
                options.push(part.args[0].literal);
            }
            else if (part.type === jinqu_1.QueryFunc.cast) {
                ctor = part.args[0].literal;
            }
            else if (part.type === jinqu_1.QueryFunc.toArray
                || part.type === jinqu_1.QueryFunc.first
                || part.type === jinqu_1.QueryFunc.single) {
                continue;
            }
            else if (part.type === jinqu_1.QueryFunc.inlineCount) {
                inlineCount = true;
            }
            else if (part.type === jinqu_1.AjaxFuncs.includeResponse) {
                includeResponse = true;
            }
            else if (part.type === exports.ODataFuncs.oDataSelect) {
                select = part;
            }
            else if (part.type === exports.ODataFuncs.expand || part.type === exports.ODataFuncs.thenExpand) {
                expands.push(part);
            }
            else if (part.type === exports.ODataFuncs.apply) {
                ctor = null;
                apply = part;
            }
            else if (orderFuncs.indexOf(part.type) !== -1) {
                orders = [part];
            }
            else if (thenFuncs.indexOf(part.type) !== -1) {
                orders.push(part);
            }
            else if (otherFuncs.indexOf(part.type) !== -1) {
                params[part.type] = part.args[0];
            }
            else {
                throw new Error(part.type + " is not supported.");
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (orders.length) {
        var value = orders.map(function (o) {
            var v = handlePartArg(o.args[0]);
            return descFuncs.indexOf(o.type) !== -1 ? (v + " desc") : v;
        }).join(",");
        queryParams.push({ key: "$orderby", value: value });
    }
    if (select) {
        queryParams.push({ key: "$select", value: select.args[0].literal.join(",") });
    }
    if (expands.length) {
        var es_1 = {};
        var ce_1;
        expands.forEach(function (e) {
            var exp = e.args[0].literal;
            var sel = e.args[1].literal;
            var fil = handlePartArg(e.args[2]);
            var col;
            if (e.type === exports.ODataFuncs.expand) {
                col = es_1;
            }
            else {
                if (!ce_1) {
                    throw new Error("'thenExpand' must be called after an 'expand'.");
                }
                col = ce_1.children;
            }
            ce_1 = col[exp] || (col[exp] = { children: {} });
            ce_1.select = sel;
            ce_1.filter = fil;
        });
        queryParams.push({ key: "$expand", value: walkExpands(es_1) });
    }
    if (inlineCount) {
        queryParams.push({ key: jinqu_1.QueryFunc.inlineCount, value: "" });
    }
    if (includeResponse) {
        queryParams.push({ key: jinqu_1.AjaxFuncs.includeResponse, value: "" });
    }
    for (var p in params) {
        if (params.hasOwnProperty(p)) {
            queryParams.push({ key: "$" + p, value: handlePartArg(params[p]) });
        }
    }
    if (apply) {
        var keySelector = handlePartArg(apply.args[0]);
        var valueSelector = apply.args[1] && handlePartArg(apply.args[1]);
        if (valueSelector) {
            queryParams.push({ key: "$apply", value: "groupby((" + keySelector + "),aggregate(" + valueSelector + "))" });
        }
        else {
            queryParams.push({ key: "$apply", value: "groupby((" + keySelector + "))" });
        }
    }
    return [queryParams, options, ctor];
}
exports.handleParts = handleParts;
function handlePartArg(arg) {
    return arg.literal != null || arg.exp == null
        ? arg.literal
        : handleExp(arg.exp, arg.scopes);
}
function handleExp(exp, scopes) {
    var rl = rootLambda;
    rootLambda = true;
    var parameters = exp.type === "Func" /* Func */ ? exp.parameters : [];
    var retVal = expToStr(exp, scopes, parameters);
    rootLambda = rl;
    return retVal;
}
function expToStr(exp, scopes, parameters) {
    switch (exp.type) {
        case "Literal" /* Literal */:
            return literalToStr(exp);
        case "Variable" /* Variable */:
            return variableToStr(exp, scopes, parameters);
        case "Unary" /* Unary */:
            return unaryToStr(exp, scopes, parameters);
        case "Group" /* Group */:
            // little hack to workaround object grouping
            // "c => ({ id: c.id })" expression generates "(id)" and OData does not support that
            // but we have to use that syntax to use ObjectExpression with lambdas
            // so, we unwrap groups if they contain only one ObjectExpression
            var gexp = exp;
            if (gexp.expressions.length === 1 && gexp.expressions[0].type === "Object" /* Object */) {
                return expToStr(gexp.expressions[0], scopes, parameters);
            }
            return groupToStr(gexp, scopes, parameters);
        case "Object" /* Object */:
            return objectToStr(exp, scopes, parameters);
        case "Binary" /* Binary */:
            return binaryToStr(exp, scopes, parameters);
        case "Member" /* Member */:
            return memberToStr(exp, scopes, parameters);
        case "Func" /* Func */:
            return funcToStr(exp, scopes, parameters);
        case "Call" /* Call */:
            return callToStr(exp, scopes, parameters);
        default:
            throw new Error("Unsupported expression type " + exp.type);
    }
}
function literalToStr(exp) {
    return valueToStr(exp.value);
}
function variableToStr(exp, scopes, parameters) {
    var name = exp.name;
    if (parameters.indexOf(name) !== -1) {
        return "";
    }
    var scope = scopes && scopes.find(function (s) { return name in s; });
    return (scope && valueToStr(scope[name])) || name;
}
function unaryToStr(exp, scopes, parameters) {
    return "" + getUnaryOp(exp.operator) + expToStr(exp.target, scopes, parameters);
}
function groupToStr(exp, scopes, parameters) {
    return "(" + exp.expressions.map(function (e) { return expToStr(e, scopes, parameters); }).join(",") + ")";
}
function objectToStr(exp, scopes, parameters) {
    return exp.members.map(function (m) {
        var e = expToStr(m.right, scopes, parameters);
        return e === m.name ? e : e + " as " + m.name;
    }).join(",");
}
function binaryToStr(exp, scopes, parameters) {
    var left = expToStr(exp.left, scopes, parameters);
    var op = getBinaryOp(exp.operator);
    var right = expToStr(exp.right, scopes, parameters);
    return left + " " + op + " " + right;
}
function memberToStr(exp, scopes, parameters) {
    var owner = expToStr(exp.owner, scopes, parameters);
    if (!owner) {
        return exp.name;
    }
    if (typeof owner === "object") {
        return valueToStr(owner[exp.name]);
    }
    if (exp.name === "length") {
        return "length(" + owner + ")";
    }
    return owner + "/" + exp.name;
}
function funcToStr(exp, scopes, parameters) {
    var rl = rootLambda;
    rootLambda = false;
    var prm = rl ? "" : (exp.parameters.join(",") + ": ");
    var body = expToStr(exp.body, scopes, parameters);
    return prm + body;
}
function callToStr(exp, scopes, parameters) {
    var callee = exp.callee;
    if (callee.type !== "Member" /* Member */) {
        throw new Error("Invalid function call " + expToStr(exp.callee, scopes, parameters));
    }
    var args;
    var ownerStr = expToStr(callee.owner, scopes, parameters);
    if (callee.name === "count") {
        return ownerStr ? ownerStr + "/$count" : "$count";
    }
    if (aggregateFuncs.indexOf(callee.name) !== -1) {
        return handleExp(exp.args[0], scopes) + " with " + callee.name;
    }
    args = exp.args.map(function (a) { return expToStr(a, scopes, parameters); }).join(",");
    // handle Math functions
    if (mathFuncs.indexOf(callee.name) !== -1 && ownerStr === "Math") {
        return callee.name + "(" + args + ")";
    }
    // any and all are the only functions which can be called on owner
    if (callee.name === "any" || callee.name === "all") {
        return ownerStr + "/" + callee.name + "(" + args + ")";
    }
    // other supported functions takes owner as the first argument
    args = args ? ownerStr + "," + args : ownerStr;
    var oDataFunc = functions[callee.name] || callee.name.toLowerCase();
    return oDataFunc + "(" + args + ")";
}
function valueToStr(value) {
    if (Object.prototype.toString.call(value) === "[object Date]") {
        return "datetime'" + value.toISOString() + "'";
    }
    if (value == null) {
        return "null";
    }
    if (typeof value === "string") {
        return "'" + value.replace(/'/g, "''") + "'";
    }
    if (typeof value === "boolean")
        return value.toString();
    return value;
}
function walkExpands(e) {
    var expStrs = [];
    for (var p in e) {
        if (!e.hasOwnProperty(p)) {
            continue;
        }
        var exp = e[p];
        var childStr = walkExpands(exp.children);
        var subStrs = [];
        if (exp.filter) {
            subStrs.push("$filter=" + exp.filter);
        }
        if (exp.select) {
            subStrs.push("$select=" + exp.select);
        }
        if (childStr) {
            subStrs.push("$expand=" + childStr);
        }
        var expStr = subStrs.length
            ? p + "(" + subStrs.join(";") + ")"
            : p;
        expStrs.push(expStr);
    }
    return expStrs.join(",");
}
function getBinaryOp(op) {
    switch (op) {
        case "==":
        case "===": return "eq";
        case "!=":
        case "!==": return "ne";
        case ">": return "gt";
        case ">=": return "ge";
        case "<": return "lt";
        case "<=": return "le";
        case "+": return "add";
        case "-": return "sub";
        case "*": return "mul";
        case "/": return "div";
        case "%": return "mod";
        case "&&": return "and";
        case "||": return "or";
        default: return op;
    }
}
function getUnaryOp(op) {
    if (op === "!") {
        return "not ";
    }
    return op;
}
//# sourceMappingURL=shared.js.map